import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import constants from '../../../constants';
import MatchTabMWeb from './index_mWeb';
import { isSmartPhone } from '../../../utilities/helper';
import MatchTabWeb from './index_web';

const MatchTab = ({ gameType }: any) => {
  const [activeTab, setActiveTab] = useState(0);
  const { themeType = 'light' } = useSelector((state: any) => state.setting);
  const { list: fantasyCricketList } = useSelector((state: any) => state.fantasy_cricket);
  const { list: fantaysyFootballList } = useSelector((state: any) => state.fantasy_football);
  const { list: fantaysyYesOrNoList } = useSelector((state: any) => state.fantasy_yes_no);

  const {
    fixtures: fantasyCricketFixtureList,
    live: fantasyCricketLiveList,
    result: fantasyCricketResultList
  } = fantasyCricketList;
  const {
    fixtures: fantasyFootballFixtureList,
    live: fantasyFootballLiveList,
    result: fantasyFootballResultList
  } = fantaysyFootballList;

  const {
    fixtures: fantasyYesOrNoFixtureList,
    live: fantasyYesOrNoLiveList,
    result: fantasyYesOrNoResultList
  } = fantaysyYesOrNoList;

  const link = useLink();
  const [routes] = useState([
    { key: 'Fixtures', title: 'Fixtures' },
    { key: 'Live', title: 'Live' },
    { key: 'Results', title: 'Results' }
  ]);

  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressOpenWebView = (pageUrl: any, title: any) => {
    const url = `https://images-dev-v1.igamio.com/static/${pageUrl}?theme=${themeType}`;
    link.push('/iframe_page', {
      url,
      title
    });
  };
  const getFixtureList = (gameType: any) => {
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      return [...fantasyCricketFixtureList];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      return [...fantasyFootballFixtureList];
    }
    if (gameType === constants.GameType.FANTASY_YES_NO) {
      return [...fantasyYesOrNoFixtureList];
    }
  };

  const getResultList = (gameType: any) => {
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      return [...fantasyCricketResultList];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      return [...fantasyFootballResultList];
    }
    if (gameType === constants.GameType.FANTASY_YES_NO) {
      return [...fantasyYesOrNoResultList];
    }
  };

  const getLiveList = (gameType: any) => {
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      return [...fantasyCricketLiveList];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      return [...fantasyFootballLiveList];
    }
    if (gameType === constants.GameType.FANTASY_YES_NO) {
      return [...fantasyYesOrNoLiveList];
    }
  };

  return (
    <>
      {isSmartPhone ? (
        <MatchTabMWeb
          fixtureList={getFixtureList(gameType)}
          liveList={getLiveList(gameType)}
          resultList={getResultList(gameType)}
          onPressOpenWebView={onPressOpenWebView}
          onChangeTab={onChangeTab}
          activeTab={activeTab}
          routes={routes}
          onChangeIndex={onChangeIndex}
        />
      ) : (
        <MatchTabWeb
          fixtureList={getFixtureList(gameType)}
          liveList={getLiveList(gameType)}
          resultList={getResultList(gameType)}
          onPressOpenWebView={onPressOpenWebView}
          onChangeTab={onChangeTab}
          activeTab={activeTab}
          routes={routes}
          onChangeIndex={onChangeIndex}
        />
      )}
    </>
  );
};

export default MatchTab;
